export default __webpack_public_path__ + "static/media/36I-114294_-20838_0.767c2906.jpg";